export default __webpack_public_path__ + "static/media/scrollTopCircle.bf59d4b0.svg";